<template>
  <div>
    <validation-provider vid="anrede">
      <b-form-group label="Anrede">
        <b-form-select v-model="form.anrede" :options="titles"></b-form-select>
      </b-form-group>
    </validation-provider>

    <validation-provider vid="vorname" rules="required" v-slot="{ valid, errors, changed }">
      <b-form-group label="Vorname *" label-for="input-vorname">
        <b-form-input
          v-model="form.vorname"
          :state="onValidateField(valid, errors, changed)"
          type="text"
          placeholder="Vorname angeben"
        ></b-form-input>
        <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
      </b-form-group>
    </validation-provider>

    <validation-provider vid="name" rules="required" v-slot="{ valid, errors, changed }">
      <b-form-group label="Nachname *" label-for="input-name">
        <b-form-input
          v-model="form.name"
          :state="onValidateField(valid, errors, changed)"
          type="text"
          placeholder="Nachname angeben"
        ></b-form-input>
        <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
      </b-form-group>
    </validation-provider>

    <b-form-group label="Firma" label-for="input-firma">
      <b-form-input
        v-model="form.firma"
        type="text"
        placeholder="Firma angeben"
      ></b-form-input>
    </b-form-group>

    <b-form-group label="Zusatz" label-for="input-zusatz">
      <b-form-input
        v-model="form.zusatz"
        type="text"
        placeholder="Zusatz angeben"
      ></b-form-input>
    </b-form-group>

    <b-form-group label="UID" label-for="input-uid">
      <b-form-input
        v-model="form.uid"
        type="text"
        placeholder="UID angeben"
      ></b-form-input>
    </b-form-group>

    <b-form-group label="öffentliche Hand" label-for="input-oeffentliche-hand">
      <b-form-checkbox
        v-model="form.oeffentlicheHand"
        :value="true"
        :unchecked-value="false"
      />
    </b-form-group>

    <b-row>
      <b-col cols="9">
        <validation-provider vid="strasse" rules="required" v-slot="{ valid, errors, changed }">
          <b-form-group label="Strasse *" label-for="input-strasse">
            <b-form-input
              v-model="form.strasse"
              :state="onValidateField(valid, errors, changed)"
              type="text"
              placeholder="Strasse angeben"
            ></b-form-input>
            <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col class="col">
        <b-form-group label="Nr." label-for="input-haus-nr">
          <b-form-input
            v-model="form.hausNr"
            type="text"
            placeholder="Nr. angeben"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="4">
        <validation-provider vid="plz" rules="required|numeric" v-slot="{ valid, errors, changed }">
          <b-form-group label="PLZ *" label-for="input-plz">
            <b-form-input
              v-model="form.plz"
              :state="onValidateField(valid, errors, changed)"
              type="text"
              placeholder="PLZ angeben"
            ></b-form-input>
            <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col class="col">
        <validation-provider vid="ort" rules="required" v-slot="{ valid, errors, changed }">
          <b-form-group label="Ort *" label-for="input-ort">
            <b-form-input
              v-model="form.ort"
              :state="onValidateField(valid, errors, changed)"
              type="text"
              placeholder="Ort angeben"
            ></b-form-input>
            <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>

    <validation-provider vid="telefon" rules="phoneNumber" v-slot="{ valid, errors, changed }">
      <b-form-group label="Telefon *" label-for="input-telefon">
        <b-form-input
          v-model="form.telefon"
          :state="onValidateField(valid, errors, changed)"
          type="text"
          placeholder="Telefonnr. angeben"
        ></b-form-input>
        <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
      </b-form-group>
    </validation-provider>

    <validation-provider vid="email" rules="email" v-slot="{ valid, errors, changed }">
      <b-form-group id="input-group-email" label="E-Mail (Empfohlen, wenn Sie Gesuche zum Signieren an diese Person weiterleiten möchten)" label-for="input-email">
        <b-form-input
          v-model="form.email"
          :state="onValidateField(valid, errors, changed)"
          type="email"
          placeholder="E-Mail angeben"
        ></b-form-input>
        <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
      </b-form-group>
    </validation-provider>

    <validation-provider vid="land">
      <b-form-group label="Land" label-for="input-confirm-land">
        <b-form-select v-model="form.land" :options="countries"></b-form-select>
      </b-form-group>
    </validation-provider>

  </div>
</template>

<script>
  import { ValidationProvider } from 'vee-validate'
  import { validateField } from '@/helpers/formHelper.js'

  export default {
    props: {
      form: Object
    },
    components: {
      ValidationProvider
    },
    data: () => ({
      isSucceded: false,
      hasUnknownError: false,
      unknownErrorMessage: '',
      hasError: false,
      errorMessage: '',
      countries: [
        { value: 16, text: 'Schweiz' },
        { value: 17, text: 'Deutschland' },
        { value: 18, text: 'Österreich' },
        { value: 19, text: 'Lichtenstein' },
        { value: 21, text: 'Frankreich' },
        { value: 20, text: 'Italien' },
        { value: 92, text: 'Israel' },
        { value: 91, text: 'USA' },
        { value: 241, text: 'Grossbritanien' }
      ],
      titles: [
        { value: 'Herr', text: 'Herr' },
        { value: 'Frau', text: 'Frau' },
        { value: 'Herr & Frau', text: 'Herr & Frau' }
      ]
    }),
    methods: {
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .optional{
    text-decoration: underline;
  }
</style>
